
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningHeavySleet as ObiLightningHeavySleetElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-heavy-sleet.js';
 
 
 

 
 export const ObiLightningHeavySleet = createComponent({
   react: React,
   tagName: 'obi-lightning-heavy-sleet',
   elementClass: ObiLightningHeavySleetElement,
   events: {
     
   }
  });
 
 